import { render, staticRenderFns } from "./AttachExistingFile.vue?vue&type=template&id=48ec57e4&"
import script from "./AttachExistingFile.vue?vue&type=script&lang=js&"
export * from "./AttachExistingFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ec57e4')) {
      api.createRecord('48ec57e4', component.options)
    } else {
      api.reload('48ec57e4', component.options)
    }
    module.hot.accept("./AttachExistingFile.vue?vue&type=template&id=48ec57e4&", function () {
      api.rerender('48ec57e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/AttachExistingFile.vue"
export default component.exports